<template>
  <div>
    <div v-if="showList">
      <div class="row">
        <div class="col-sm-12">
          <h1 class="page-title pull-left">Trap Site Master</h1>
          <div class="pull-right btn-group">
            <button
              class="pointer btn btn-lg btn-primary"
              v-on:click="form.showEdit({})"
            >
              Create New
            </button>
          </div>
        </div>
      </div>

      <div class="panel">
        <search-fields :form="form" :fields="searchFieldsList"></search-fields>

        <loading :working="form.working()"></loading>

        <div class="panel-body" v-if="!form.working()">
          <div class="col-xs-12 table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Name/Number</th>
                  <th>Active</th>
                  <th>Address/Location</th>
                  <th>Site</th>
                  <th>GPS Coordinates</th>
                  <th>Municipality</th>
                  <th>Altitude</th>
                  <th>Zone</th>
                  <th>Trap Type</th>
                  <th>Trap Night</th>
                  <th>Trap Team</th>
                  <th>Schedule</th>
                  <th width="120"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in form.list">
                  <td>{{ item.attributes.trapNumber }}</td>
                  <td>
                    <i
                      class="fa"
                      :class="{
                        'fa-check-square-o': item.attributes.isActive,
                        'fa-square-o': !item.attributes.isActive,
                      }"
                    ></i>
                  </td>
                  <td>
                    {{ item.attributes.address }}<br />
                    {{ item.attributes.city }}, <br />
                    {{ stateName(item.attributes.stateId) }}
                    {{ item.attributes.zip }}
                  </td>
                  <td>{{ siteName(item.attributes.siteId) }}</td>
                  <td
                    class="pointer"
                    v-on:click="
                      showMap({
                        lat: item.attributes.latitude,
                        lon: item.attributes.longitude,
                      })
                    "
                  >
                    <i class="fa fa-map"></i>
                    {{ item.attributes.latitude }},
                    {{ item.attributes.longitude }}
                  </td>
                  <td>
                    {{ municipalityName(item.attributes.municipalityId) }}
                  </td>
                  <td>{{ item.attributes.altitude }}</td>
                  <td>{{ zoneName(item.attributes.zoneId) }}</td>
                  <td>{{ trapTypeName(item.attributes.trapTypeId) }}</td>
                  <td>{{ trapNightName(item.attributes.trapNightId) }}</td>
                  <td>{{ trapTeamName(item.attributes.trapTeamId) }}</td>
                  <td>
                    {{ item.attributes.scheduleStart | date }}
                    every {{ item.attributes.scheduleFrequency }} days
                  </td>

                  <td>
                    <!--<a class="pointer text-primary" v-on:click="form.showEdit({id: item.id})"><i class="fa fa-pencil" style="margin-right: 10px;"></i></a>-->
                    <router-link
                      :to="{
                        name: 'data-trap-site-details',
                        params: { id: item.id },
                      }"
                      ><i class="fa fa-ellipsis-h mr-10"></i
                    ></router-link>
                    <router-link
                      :to="{
                        name: 'data-adult-surveillances-with',
                        params: { type: 'ts', id: item.id },
                      }"
                      ><i
                        class="fa fa-file-o mr-10"
                        title="Add Adult Surveillance Data"
                      ></i
                    ></router-link>
                    <a
                      class="pointer text-danger"
                      v-on:click="form.destroy(item.id)"
                      ><i class="fa fa-times"></i
                    ></a>
                  </td>
                </tr>
              </tbody>
              <pager :form="form"></pager>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!showList">
      <div class="row">
        <div class="col-sm-12">
          <h1 class="page-title pull-left">Associate trap data</h1>
          <div class="pull-right">
            <div class="btn-group">
              <button
                class="pointer btn btn-lg"
                v-on:click="showList = !showList"
              >
                <i class="fa fa-times"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="panel">
        <div class="panel-body">
          <table class="table table-striped">
            <thead>
              <th>Name</th>
              <th>City</th>
              <th>State</th>
              <th>Location</th>
              <th>Trap Site</th>
            </thead>
            <tbody>
              <tr v-for="(zone, index) in shapeFile">
                <td>{{ zone.properties.Name }}</td>
                <td>{{ zone.properties.City }}</td>
                <td>{{ zone.properties.State }}</td>
                <td
                  class="pointer"
                  v-on:click="
                    showMap({
                      lat: zone.geometry.coordinates[1],
                      lon: zone.geometry.coordinates[0],
                    })
                  "
                >
                  <i class="fa fa-map"></i> 1 point
                </td>
                <td>
                  <div class="input-group">
                    <span class="input-group-addon">Action</span>
                    <select
                      class="form-control"
                      v-model="trapAssociations[index]['id']"
                    >
                      <option value="ignore">Ignore</option>
                      <option value="new">Create New</option>
                      <option v-for="item in form.list" v-bind:value="item.id"
                        >{{ siteName(item.attributes.siteId) }} -
                        {{ item.attributes.trapNumber }}</option
                      >
                    </select>
                  </div>
                  <div class="input-group">
                    <span class="input-group-addon">Site</span>
                    <select
                      class="form-control"
                      v-model="trapAssociations[index]['siteId']"
                    >
                      <option></option>
                      <option v-for="item in sites" v-bind:value="item.id">{{
                        item.attributes.name
                      }}</option>
                    </select>
                  </div>
                  <div class="input-group">
                    <span class="input-group-addon">Trap Number</span>
                    <input
                      type="text"
                      name="trapNumber"
                      placeholder="trap number"
                      class="form-control"
                      v-model="trapAssociations[index]['trapNumber']"
                    />
                  </div>
                  <div class="input-group">
                    <span class="input-group-addon">Active</span>
                    <input
                      type="checkbox"
                      name="isActive"
                      id="isActive"
                      v-model="trapAssociations[index]['isActive']"
                    />
                  </div>
                  <div class="input-group">
                    <span class="input-group-addon">Trap Type</span>
                    <select
                      class="form-control"
                      v-model="trapAssociations[index]['trapTypeId']"
                    >
                      <option></option>
                      <option
                        v-for="item in trapTypes"
                        v-bind:value="item.id"
                        >{{ item.attributes.trap }}</option
                      >
                    </select>
                  </div>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="7">
                  <button
                    class="btn btn-primary pull-right"
                    v-on:click="createTraps()"
                  >
                    Save
                  </button>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>

    <trap-site-form :form="form"></trap-site-form>

    <google-map ref="gmap"></google-map>

    <input
      type="file"
      id="shape"
      v-on:change="readShape()"
      accept=".zip,application/octet-stream,application/zip,application/x-zip,application/x-zip-compressed"
    />
  </div>
</template>

<script>
import TrapSitesService from '@/services/TrapSitesService';
import Form from '@/utils/form';
import loader from '@/utils/loader';
import trapSiteForm from '@/components/forms/trap_site_details';
import pager from '@/components/forms/pager';
import googleMap from '@/components/googleMap';
import searchFields from '@/components/search_fields';
import loading from '@/components/loading';
import store from '@/store';

export default {
  name: 'trap-sites',

  components: {
    pager,
    trapSiteForm,
    googleMap,
    searchFields,
    loading,
  },

  props: ['id', 'type'],

  data() {
    const { $props, $router } = this;
    const successCallback = () => {
      if ($props.type == 's') {
        $router.push({
          name: 'data-adult-surveillances-with',
          params: {
            ...$props,
          },
        });
      }
    };
    return {
      showList: true,
      shapeFile: null,
      trapAssociations: [],
      coordinates: [],
      searchFieldsList: {
        trapNumber: 'Trap #',
        site: 'Site',
        location: 'Location',
        trapType: 'Trap Type',
      },
      form: new Form(TrapSitesService, {
        successCallback,
      }),
    };
  },

  methods: {
    contractName(id) {
      return this.$store.getters.contractNameById(id);
    },
    municipalityName(id) {
      return this.$store.getters.municipalityNameById(id);
    },
    trapTeamName(id) {
      return this.$store.getters.trapTeamNameById(id);
    },
    trapTypeName(id) {
      return this.$store.getters.trapTypeNameById(id);
    },
    trapNightName(id) {
      return this.$store.getters.trapNightNameById(id);
    },
    zoneName(id) {
      return this.$store.getters.zoneNameById(id);
    },
    siteName(id) {
      return this.$store.getters.siteNameById(id);
    },
    stateName(id) {
      return this.$store.getters.stateNameById(id);
    },

    getShape() {
      document.querySelector('#shape').click();
    },

    readShape() {
      let files = document.querySelector('#shape').files;
      if (!files.length) {
        return;
      }

      var that = this;
      let fileReader = new FileReader();
      fileReader.onloadend = () => {
        document.querySelector('#shape').value = null;

        TrapSitesService.shape({ shape: fileReader.result }).then((data) => {
          that.shapeFile = data;
          _.forEach(data, (item, index) => {
            that.trapAssociations[index] = {
              id: 'ignore',
              trapNumber: null,
              latitude: item.geometry.coordinates[1],
              longitude: item.geometry.coordinates[0],
              isActive: true,
              location: null,
              siteId: null,
              trapTypeId: null,
            };
          });

          that.showList = false;
        });
      };
      fileReader.readAsDataURL(files[0]);
    },

    createTraps() {
      TrapSitesService.createShapes({ traps: this.trapAssociations }).then(
        () => {
          this.form.getList();
          this.showList = true;
        }
      );
    },

    showMap(coordinates) {
      this.$refs.gmap.showMap(coordinates);
    },
  },

  computed: {
    sites() {
      return this.$store.getters.sites;
    },
    trapTypes() {
      return this.$store.getters.trapTypes;
    },
  },

  created() {
    this.onHideWithId = (id) => {
      if (this.$props.id) {
        return;
      }
      if (this.$route.path.indexOf('trap-site') > -1 && this.$props.id) {
        this.$router.push({
          name: 'data-site-details',
          params: { id: this.$props.id },
        });
      }
    };
    window.bus.$on('item-created', this.onHideWithId);

    this.onHideNoId = () => {
      if (this.$route.path.indexOf('trap-site') > -1 && this.$props.id) {
        this.$router.push({
          name: 'data-site-details',
          params: { id: this.$props.id },
        });
      }
    };
    $(document).on('hide.bs.modal', this.onHideNoId);
  },

  mounted() {
    loader.lookups().then(() => {
      this.form.getList();
    });

    if (this.$props.id) {
      this.form.showEdit({});
      this.form.siteSearch.term = this.siteName(this.$props.id);
      this.form.onSiteSearch('siteId');
    }
  },

  destroyed() {
    $(document).off('hide.bs.modal', this.onHideNoId);
    $(document).off('hide.bs.modal', this.onHideWithId);
  },
};
</script>

<style lang="scss"></style>
